import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom';
import useRoles from '../../hooks/useRoles';

const CategoryList = () => {
  const { hasRole } = useRoles();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get('/categories');
        setCategories(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/categories/${id}`);
      setCategories(categories.filter((category) => category.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container mt-4">
      <h1>Категории</h1>
      {hasRole('CreateCategory') && (
        <Link to="/categories/new" className="btn btn-primary mb-3">
          Добавить новую категорию
        </Link>
      )}
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Название</th>
            <th>Действие</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => (
            <tr key={category.id}>
              <td>{category.name}</td>
              <td>
                
                {hasRole('UpdateCategory') && (
                  <Link
                    to={`/categories/${category.id}/edit`}
                    className="btn btn-sm btn-warning me-2"
                  >
                    Редактировать
                  </Link>
                )}
                {hasRole('DeleteCategory') && (
                  <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(category.id)}
                  >
                    Удалить
                  </button>
                )}
                
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CategoryList;